import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from './api.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OrderSummaryServiceService {
  public paid: number = 0;
  public unpaid: number = 0;
  public inpayment: number = 0;
  public total: number = 0;
  private subscription = new Subscription();
  constructor(
    private api: ApiService
  ) { }
  update(): void {
    this.subscription.unsubscribe();
    this.subscription = this.api.getOrderSummary()
    .subscribe({
      next: (response) => {
        if (response.status !== 1) return;
        this.total = response.data.total;
        this.paid = response.data.total_paid;
        this.inpayment = response.data.total_in_payment;
        this.unpaid = response.data.total_unpaid;
      },
      error: (error: HttpErrorResponse) => {
        console.error('API Error: ', error);
      }
    })
  }
}
